export const KeywordGenerationButton = ({ t, onGenerateKeywords }) => {
  return (
    <div className="d-flex justify-content-end mb-3">
      <button className="bt-gap-generation" onClick={onGenerateKeywords}>
        {t('Récupérer GAP et/ou maillage')}
      </button>
    </div>
  );
};
